/**
 * Declare your ES6 Style IMPORTS
 * @type {[type]}
 */
import { nav } from './modules/nav';
import { browsers } from './modules/browsers';
import { corrections } from './modules/correctif';
import { utils } from './modules/utils';
import { _, each } from 'lodash';
import { config } from './config';
import { animations } from './modules/animations';
/**
 * Declare your browserify imports
 * @type {[type]}
 */

/**
 * Utilities
 * @type {[type]}
 */
const Log = function (param) {
  if (config.debug) {
    console.log('¯\_(ツ)_/¯', param);
  }
};
const Warn = function (param) {
  if (config.debug) {
    console.warn('(づ｡◕‿‿◕｡)づ', param);
  }
};
const Err = function (param) {
  if (config.debug) {
    console.error('(ノಠ益ಠ)ノ彡┻━┻', param);
  }
};

/**
 * Namespacing all the code, is the name is already existing it just expands it.
 * @type {[type]}
 */
var sodicob = sodicob || {};
sodicob.modules = sodicob.modules || {};

/**
 * Core function
 * @param  {array} core methods you need to start
 * @return {object} core methods that are publicly exposed
 */
sodicob.core = (function () {
  var publicMethods = {};
  var privateMethods = {};

  publicMethods.nav = nav;
  publicMethods.utils = utils;
  publicMethods.browsers = browsers;

  privateMethods.globals = function (options) {
    utils.autoReflower();
    nav.toggle(options.trigger, options.selector);
    nav.toggleAll(options.subtrigger, options.submenu);
    nav.logoAnim(options);
    animations.smoothScroll();
  };

  privateMethods.nav = function (options) {
    animations.tilt(options);
  };

  privateMethods.scroller = function (options) {
    animations.scrollReveal(options);
  };

  privateMethods.fadeFromTop = function (options) {
    animations.scrollReveal(options);
  };

  privateMethods.garage = function(options){
    corrections.addClass(options);
  };
  privateMethods.connectee = function(options){
    corrections.addClass(options);
  };
  privateMethods.traditionnel = function(options){
    corrections.addClass(options);
  };
  privateMethods.renovation = function(options){
    corrections.addClass(options);
  };
  privateMethods.bso = function(options){
    corrections.addClass(options);
  };
  privateMethods.flagios = function(options){
    corrections.addClass(options);
  };

  /**
   * Init function, initialize any method you want with the config object you've given
   * @param  {[type]} methodToStart [description]
   * @return {[type]}                [description]
   */
  const _launcher = function(methodToStart) {
    _.each(methodToStart, function (module) {
      if (privateMethods[module.name]) {
        Log([module.name + ' initialized', module.config]);
        return privateMethods[module.name](module.config);
      } else {
        Warn([module + ' does not exist']);
        return false;
      }
    });
  };

  return {
    launcher : _launcher,
    methods: publicMethods
  };

})();
window.sodicob = sodicob;
